/* eslint-disable prefer-destructuring */
// * Primary
// * Secondary
// * Accent

// * Neutral_1
// * Neutral_2
// * Neutral_3

// * Font = Light / Dark
// * Button Style = Solid / Ghost

const theme = {
  borders: {},
  borderWidths: [],
  borderStyles: [],
  radii: [],
  breakpoints: ['374px', '413px', '768px', '1023px', '1279px', '1439px'],
  media: {
    grid: '1440px',
    'grid-gutter': ['10px', '20px', '60px', '60px'],
  },
  colors: {
    // * Not prodigy colours, using for disbabled button
    grey: '#74777a',
    'pale-grey': '#f6f6f7',
    // * Prodigy Colours
    orange: '#FF5C0B',
    'dark-orange': '#E64F00',
    'darkest-orange': '#C03A00',
    // * Prodigy Neutral Colours
    cream: '#F7E9DB',
    sand: '#CBAC92',
    charcoal: '#2B2A29',
    black: '#1A1E26',
    white: '#FFFFFF',
    // * Prodigy Primary/Secondary/Accent Colours
    maroon: '#6F1F3A',
    fuschia: '#EC008C',
    bubblegum: '#FE96BE',
    sunshine: '#FFC900',
    skyblue: '#A9E7F5',
    lavender: '#BFAFEF',
    grass: '#95C13D',
    ocean: '#245353',
    'dark-ocean': '#1C3D3D',
    'darkest-ocean': '#102323',
  },
  fonts: {
    sans: '"Work Sans", Helvetica, Arial, sans-serif',
    brush: '"Quickbrush", Helvetica, Arial, sans-serif',
  },
  fontSizes: [],
  'font-weights': {
    regular: 400,
    'semi-bold': 600,
    bold: 700,
  },
  lineHeights: [],
  letterSpacings: [],
  textDecoration: {},
  space: ['10px', '20px', '30px'],
  sizes: [],
  shadows: {
    small: '0px 2px 4px 0px rgba(0, 0, 0, 0.16)',
  },
  transitions: [],
  zIndices: [0, 1, 2, 3, 6, 12, 24, 48, 96],
};

export const defaultTheme = {
  primary: '#6F1F3A',
  secondary: '#FF5C0B',
  accent: '#A9E7F5',
  neutral_1: '#FFFFFF',
  neutral_2: '#F7E9DB',
  neutral_3: '#CBAC92',
  text_light: '#FFFFFF',
  // text_dark: '#2b2c32',
  text_dark: '#1A1E26',
  text_primary: '#FFFFFF',
  text_secondary: '#1A1E26',
  text_accent: '#A9E7F5',
};

// * Custom Breakpoints
theme.breakpoints.xs = theme.breakpoints[0];
theme.breakpoints.sm = theme.breakpoints[1];
theme.breakpoints.md = theme.breakpoints[2];
theme.breakpoints.lg = theme.breakpoints[3];
theme.breakpoints.xl = theme.breakpoints[4];
theme.breakpoints.max = theme.breakpoints[5];

// * Font Themes
theme.fonts.primary = theme.fonts.sans;
theme.fonts.secondary = theme.fonts.brush;

// * Primary Theme Colours
theme.colors.primary = theme.colors.maroon;
theme.colors.secondary = theme.colors.orange;
theme.colors.accent = theme.colors.skyblue;

// * Neutral theme Colors
theme.colors.neutral_1 = theme.colors.white;
theme.colors.neutral_2 = theme.colors.cream;
theme.colors.neutral_3 = theme.colors.sand;

// * Standard Text Theme Colors
theme.colors['text-light'] = theme.colors.white;
theme.colors['text-dark'] = theme.colors.black;

// * Primary Text Theme Colors
theme.colors['text-primary'] = theme.colors.white;
theme.colors['text-secondary'] = theme.colors.black;
theme.colors['text-accent'] = theme.colors.orange;

export default theme;
